<!-- Ported from the Polaris kit: src/components/ui/switch/Switch.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Divergência aprovada 2026-10-23: fix direto no port (kit indisponível no
     workspace; ver .planning/phases/01.1.2-switch-do-kit-e-modal-de-confirma-o-no-bulk-delete/
     01.1.2-RESEARCH.md). Re-portar quando o kit reaparecer.
     Hand change (2026-10-23, UI-01): dimensões restauradas para o canônico do
     shadcn-vue atual (h-[1.15rem] w-8, thumb calc(100%-2px)) + p-0 no root.
     O p-0 é obrigatório NESTE app: _base.scss aplica `py-1 px-2.5` em todo
     `button` e o SwitchRoot renderiza um <button> — sem o reset, o padding
     horizontal empurrava o thumb para o meio da trilha e o vertical o achatava
     (sintomas reportados pelo owner). O Checkbox.vue do kit já trazia p-0;
     o Switch, não. Ao re-portar, manter o p-0. -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { SwitchRoot, SwitchThumb, useForwardPropsEmits } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  defaultValue: { type: null, required: false },
  modelValue: { type: null, required: false },
  disabled: { type: Boolean, required: false },
  id: { type: String, required: false },
  value: { type: String, required: false },
  trueValue: { type: null, required: false },
  falseValue: { type: null, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  name: { type: String, required: false },
  required: { type: Boolean, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const emits = defineEmits(['update:modelValue']);

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <SwitchRoot
    v-slot="slotProps"
    data-slot="switch"
    v-bind="forwarded"
    :class="
      cn(
        'peer data-[state=checked]:bg-polaris-primary data-[state=unchecked]:bg-polaris-input focus-visible:border-polaris-ring focus-visible:ring-polaris-ring/50 dark:data-[state=unchecked]:bg-polaris-input/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-solid border-transparent p-0 shadow transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        props.class
      )
    "
  >
    <SwitchThumb
      data-slot="switch-thumb"
      :class="
        cn(
          'bg-polaris-background dark:data-[state=unchecked]:bg-polaris-foreground dark:data-[state=checked]:bg-polaris-primary-foreground pointer-events-none block size-4 rounded-full ring-[0px] transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0 p-0'
        )
      "
    >
      <slot name="thumb" v-bind="slotProps" />
    </SwitchThumb>
  </SwitchRoot>
</template>
